import ColorHash from 'color-hash-ts';

import AppColors from 'config/AppColors';
import { useTranslation } from 'react-i18next';
import { createUseStyles } from 'react-jss';

export type SymptomsChartProps = {
  dayValues: string[][];
};

const useStyles = createUseStyles({
  symptomLegend: {
    margin: '0px 12px 0px 0px',
    display: 'inline-flex',
    alignItems: 'center',
    color: AppColors.text.veryLightGray,
  },
  symptomLegendDot: {
    height: 8,
    width: 8,
    display: 'inline-block',
    marginRight: 4,
    borderRadius: '50%',
  },
});

const SymptomsChart: React.FC<SymptomsChartProps> = ({ dayValues }) => {
  const { t } = useTranslation();
  const colorHash = new ColorHash();

  const styles = useStyles();

  const allSymptoms = new Set<string>();
  dayValues.forEach(daySymptoms => {
    daySymptoms.forEach(symptom => allSymptoms.add(symptom));
  });

  return (
    <div>
      {Array.from(allSymptoms)
        .sort()
        .reverse()
        .map(symptom => (
          <span className={styles.symptomLegend} key={symptom}>
            <div className={styles.symptomLegendDot} style={{ backgroundColor: `${colorHash.hex(symptom)}` }} />
            {t(`symptomTracking.survey.symptoms.${symptom}`)}
          </span>
        ))}
    </div>
  );
};
export default SymptomsChart;
